import { Text, TextStyle } from "pixi.js";
import { ButtonWithScaleAnimation } from "../../../common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";

export class UpgradeButton extends ButtonWithScaleAnimation {
    private static readonly BUTTON_TEXT = "UPGRADE";

    public constructor(commonResources: CommonResourcesPackage) {
        super(commonResources.assets_common_ui_button_green_png);
        this.defaultView.width = 280;
        this.defaultView.height = 140;
        const innerText = new Text(UpgradeButton.BUTTON_TEXT, new UpgradeButtonTextStyle());
        innerText.position.set(this.width * 0.5 - innerText.width * 0.5, this.height * 0.5 - innerText.height * 0.5);
        this.addChild(innerText);
    }
}

class UpgradeButtonTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 66,
            fill: 'FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.7,
            dropShadowBlur: 4,
            dropShadowColor: '0D0606',
            dropShadowDistance: 3
        });
    }
}
